/* ============================================================================
   SMUD — JS del cart drawer, copiado del theme publicado.

   En el theme publicado estas funciones viven sueltas en layout/theme.liquid.
   Acá van en su propio archivo, que carga la sección del cart drawer (está en
   todas las páginas), así no se toca el layout.

   1. Los botones − / + del line-item (snippets/line-item.liquid) llaman a
      decreaseQuantity() / increaseQuantity() con onclick. Mueven el input y le
      piden al <line-item-quantity> nativo del theme que actualice el carrito.
      Código idéntico al publicado.

   2. El handler global de `.ajax-add-to-cart`. En el publicado es jQuery; acá
      Evergreen no carga jQuery, así que es el mismo comportamiento en JS plano:
      agrega al carrito (con el form si hay, o con data-variant-id), pone el
      spinner `ls-is-loading` mientras tanto, y al terminar refresca y abre el
      cart drawer. Lo usan los botones "Añadir" de las product cards
      (new-product-card) y del Video Slider, que en Evergreen no tenían a nadie
      escuchándolos.
   ========================================================================== */

function increaseQuantity(input) {
  input.stepUp();
  changeLineItemQuantity(input);
}

function decreaseQuantity(input) {
  input.stepDown();
  changeLineItemQuantity(input);
}

function changeLineItemQuantity(input) {
  const lineKey = input.getAttribute('data-line-key');
  const targetQuantity = parseInt(input.value);
  const lineItemQuantityElement = input.closest('line-item-quantity');
  lineItemQuantityElement._changeLineItemQuantity(lineKey, targetQuantity);
}

(function () {
  'use strict';

  if (window.__smudAjaxAddToCart) return;
  window.__smudAjaxAddToCart = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ajax-add-to-cart');
    if (!trigger) return;

    event.preventDefault();

    if (trigger.classList.contains('ls-is-loading')) return;
    trigger.classList.add('ls-is-loading');

    function removeLoader() {
      trigger.classList.remove('ls-is-loading');
    }

    var form = trigger.closest('form');
    var body;
    var headers = { 'X-Requested-With': 'XMLHttpRequest' };

    if (form) {
      body = new URLSearchParams(new FormData(form));
      headers['Content-Type'] = 'application/x-www-form-urlencoded';
    } else if (trigger.dataset.variantId) {
      body = JSON.stringify({ id: trigger.dataset.variantId, quantity: 1 });
      headers['Content-Type'] = 'application/json';
    } else {
      console.error('No form or variant ID found.');
      removeLoader();
      return;
    }

    fetch('/cart/add.js', { method: 'POST', headers: headers, body: body })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        removeLoader();

        var cartDrawerSlide = document.querySelector('#cart-drawer');
        if (cartDrawerSlide) {
          cartDrawerSlide._onCartRefresh().then(function () { cartDrawerSlide.show(); });
        }
      })
      .catch(function () {
        console.error('Error adding item to cart.');
        removeLoader();
      });
  });
})();

/* ============================================================================
   Protección de envío: el interruptor agrega o saca el producto del carrito.

   Hace lo mismo que el theme cuando cambia una cantidad: pide las secciones del
   cajón junto con el cambio y dispara `cart:change` con el carrito nuevo, así se
   redibuja el cajón (con el interruptor en su estado real) y se actualiza el
   contador del header. Si algo falla, el interruptor vuelve a como estaba.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__smudShippingProtection) return;
  window.__smudShippingProtection = true;

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function seccionesDelCajon() {
    var secciones = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: secciones }
    }));
    return secciones;
  }

  function avisar(carrito, baseEvent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: baseEvent, cart: carrito }
    }));
  }

  function cambiar(input) {
    var tarjeta = input.closest('.smud-sp');
    var variante = tarjeta && tarjeta.dataset.variantId;
    if (!variante) return;

    var prender = input.checked;
    tarjeta.classList.add('is-loading');

    var secciones = seccionesDelCajon();
    var pedido;

    if (prender) {
      pedido = fetch(raiz() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }], sections: secciones })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (agregado) {
          return fetch(raiz() + 'cart.js').then(function (r) { return r.json(); }).then(function (carrito) {
            carrito.sections = agregado.sections;
            avisar(carrito, 'variant:add');
          });
        });
    } else {
      pedido = fetch(raiz() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(variante), quantity: 0, sections: secciones })
      })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(function (carrito) { avisar(carrito, 'line-item:change'); });
    }

    pedido.catch(function () {
      input.checked = !prender;
      tarjeta.classList.remove('is-loading');
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.smud-sp__input')) cambiar(e.target);
  });
})();
